var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"antialiased text-gray-900 flex flex-col min-h-screen bg-gray-200",attrs:{"id":"app"}},[_c('router-view',{staticClass:"flex-1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }